"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.spacing = void 0;

var _styledComponents = require("styled-components");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var small = 600;
var medium = 1024;
var large = 1328;
var maxContentWidth = '1328px';
var maxPageWidth = '1920px';
var borderRadius = '8px';
var mediaQueries = {
  mediaMediumPlus: function mediaMediumPlus() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], small + 1, _styledComponents.css.apply(void 0, arguments));
  },
  mediaLargePlus: function mediaLargePlus() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], medium + 1, _styledComponents.css.apply(void 0, arguments));
  },
  mediaXL: function mediaXL() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], large + 1, _styledComponents.css.apply(void 0, arguments));
  },
  mediaBreakpoint: function mediaBreakpoint(args, breakpoint) {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], breakpoint + 1, _styledComponents.css.apply(void 0, _toConsumableArray(args)));
  }
};
var colors = {
  // Base colors
  indigo: '#0f0a3a',
  coral: '#ff6648',
  teal: '#1ac490',
  yellow: '#f4ee22',
  neutral: '#f6f2f1',
  grey: '#3a384b',
  // Variations
  // 100 represents the base color, anything < 100 is lighter and > 100 is darker
  indigo20: '#eaebf7',
  indigo30: '#d6d8f0',
  indigo60: '#251991',
  indigo80: '#160f57',
  indigo120: '#08051d',
  indigo140: '#04030f',
  coral60: '#ff9f8c',
  coral80: '#ff826a',
  coral120: '#ff4a26',
  coral140: '#ff3b15',
  teal60: '#3de5b2',
  teal80: '#1fe1a6',
  teal120: '#18b585',
  teal140: '#16a67a',
  yellow20: '#fff5d6',
  yellow60: '#f8f473',
  yellow80: '#f6f253',
  yellow120: '#e8e20c',
  yellow140: '#d8d20b',
  neutral80: '#faf8f8',
  neutral120: '#ede5e3',
  neutral140: '#e4d9d6',
  neutral200: '#5c5a6a',
  neutral220: '#3a384b',
  grey20: '#f0f0f5',
  grey40: '#cccbd4',
  grey60: '#9a98ab',
  grey80: '#73738c',
  grey120: '#08051c'
};
var semanticColors = {
  bodyTextColor: colors.neutral200,
  primaryColor: colors.indigo,
  textColor: colors.indigo120,
  textColorLight: colors.neutral220
};
var formColors = {
  disabled: '#9c9ba5',
  helperText: semanticColors.bodyTextColor,
  inputBorder: '#9c9ba5',
  errorLight: '#f7cbcc',
  errorDark: '#9c3438',
  warningLight: '#fdfdd4',
  warningDark: '#8a6d3b',
  sapphire: '#303bb2',
  veryLightBlue: '#e8e9ec',
  cloudyBlue: '#bfc5cb',
  greyishBrown: '#4a4a4a',
  brownGrey: '#979797'
};
var legacyColors = {
  almostWhite: '#f9fbfc',
  graphiteLight: '#f7f8f9',
  graphiteDarker: '#283643',
  wasabi: '#9de89f',
  pink: '#e0457b',
  greyLighter: '#e2e5e8',
  greyDarker: '#6f7d8a',
  greyLight: '#d8d8d8',
  boxShadowGrey: '#9e9e9e',
  amber: '#fae376',
  purple: '#cbceec',
  orangePumpkin: '#f78105',
  preApprovedGreen: '#127860'
};
var spacing = {
  spacingXS: '8px',
  spacingS: '16px',
  spacingM: '24px',
  spacingML: '32px',
  spacingL: '40px',
  spacingXL: '48px',
  spacing2XL: '64px',
  spacing3XL: '128px'
};
exports.spacing = spacing;
var fontFamilies = {
  buenosAires: "'Buenos Aires', 'Source Sans Pro', Arial, sans-serif",
  sansPro: "'Source Sans Pro', 'Helvetica Neue', sans-serif"
};

var _default = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colors), semanticColors), formColors), legacyColors), spacing), mediaQueries), fontFamilies), {}, {
  borderRadius: borderRadius,
  large: large,
  medium: medium,
  small: small,
  maxContentWidth: maxContentWidth,
  maxPageWidth: maxPageWidth
});

exports["default"] = _default;